//Plantilla de archivo API
let prefix = '/api/failuresCatalogs';

function getFailures() {
    return window.axios.get(prefix + '/index');
}
function addFailure(data) {
    return window.axios.post(prefix, data);
}
function updateFailure(id, data) {
    return window.axios.patch(prefix + '/' + id, data);
}
function deleteFailure(id) {
    return window.axios.delete(prefix + '/' + id);
}

export default {
    getFailures, addFailure, updateFailure, deleteFailure
}